<template>
    <div class="lg:border-b lg:border-a-brown-d7c7b8 lg:pb-6">
        <div class="flex py-4">
            <div class="ml-0 mr-auto my-auto text-14 lg:text-16 font-bold text-a-brown-502314">{{lbl.shoppingcart.request_tax}}</div>
            <img @click="toggleRequestTax()"
                class="mr-0 ml-auto my-auto cursor-pointer" 
                v-if="isRequestTax" 
                src="@/assets/image/button-on-brown.svg" />
            <img @click="toggleRequestTax()"
                class="mr-0 ml-auto my-auto cursor-pointer" 
                v-else 
                src="@/assets/image/button-off-brown.svg" />
        </div>
        <div class="bg-a-egg-e9dac5 rounded-10 p-4" v-if="isRequestTax">
            <TaxAddressList
                ref="tax-list"
                @onEditAddress="clickEditAddress($event)"
                @onDeleteAddress="clickDeleteAddress($event)"
            ></TaxAddressList>
            <div class="px-8 lg:px-24">
                <WhiteButton
                    @click="clickAddTax()"
                    customClass="flex p-2 w-full">
                    <img class="ml-auto mr-2 my-auto" src="@/assets/icon/ic-add-red-2.svg" />
                    <div class="ml-0 mr-auto text-a-red-d62300 text-14 lg:text-16 font-bold">{{lbl.tax.btn_add_tax}}</div>
                </WhiteButton>
            </div>
        </div>
    </div>
</template>

<script>
//component
import TaxAddressList from "@/module/Address/TaxAddress/component/TaxAddressList.vue";
import WhiteButton from "@/components/Button/WhiteButton.vue";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from '@/mixin/LocaleMixin.js';
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";
export default {
    name: "TaxInvoice",
    inject: ['DeliveryStore','PlaceOrderStore'],
    mixins: [ModalMixin,LocaleMixin],
    components: {
        TaxAddressList,
        WhiteButton
    },
    props: {
        disableTaxInvoice: { type: Boolean, default: false}
    },
    data: function() {
        return {
            isRequestTax: false,
        };
    },
    created: function() {
        if (this.disableTaxInvoice) {
            this.isRequestTax = false;
            this.PlaceOrderStore.state.placeOrder.useTax = false;
        } else { 
            this.isRequestTax = this.PlaceOrderStore.state.placeOrder.useTax;
        }
    },
    methods: {
        toggleRequestTax: function() {
            if (this.disableTaxInvoice) {
                return;
            }
            this.isRequestTax = !this.PlaceOrderStore.state.placeOrder.useTax;
            this.PlaceOrderStore.state.placeOrder.useTax = !this.PlaceOrderStore.state.placeOrder.useTax;
            this.PlaceOrderStore.methods.updatePlaceOrder();
        },
        clickAddTax: function() {
            this.DeliveryStore.methods.removeTaxAddress();
            this.$router.push('/addtaxaddress')
        },
        clickEditAddress: function(address) {
            console.log(address)
            this.DeliveryStore.methods.initTaxAddress();
            this.DeliveryStore.state.taxAddress = address;
            this.$router.push('/edittaxaddress');
        },
        clickDeleteAddress: function(address) {
            this.modal.confirmModal.clearModal()
                    .setMsg("ต้องการลบ Tax Address ?")
                    .show()
            this.modal.confirmModal.onClickOk(() => {
                this.apiDeleteAddress(address);
            });
        },

        apiDeleteAddress: function(address) {
            this.modal.loadingModal.show();

            BzbsAddressList.apiDeleteTaxAddress(address.rowKey).subscribe({
                next: () => {
                    this.modal.loadingModal.hide();
                    this.reloadAddressList();
                },
                error: (err) => {
                    this.modal.loadingModal.hide();
                    this.errorApi(err);
                },
            });
        },
        reloadAddressList: function() {
            this.$refs['tax-list'].getAddressList();
        },
        getData: function() {
            if (!this.isRequestTax) {
                return '';
            }
            return this.$refs['tax-list'].getData();
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    .address {
        width: calc(100% - 56px);
        @extend %ellipsis-1;
    }
</style>